import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoComponent } from './logo.component';
import { AngularSvgIconModule } from 'angular-svg-icon';

@NgModule({
  declarations: [LogoComponent],
  imports: [CommonModule, AngularSvgIconModule],
  exports: [LogoComponent],
})
export class LogoModule {}
